import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Truck } from "../../../types";
import { updateEntryDirection } from "../../../utils/api";

interface DirectionEditModalProps {
  open: boolean;
  onClose: () => void;
  truck: Truck | Truck[];
  onDirectionChange?: (truck: Truck, direction: "in" | "out") => void;
}

export function DirectionEditModal({
  open,
  onClose,
  truck,
  onDirectionChange,
}: DirectionEditModalProps): React.JSX.Element {
  const [direction, setDirection] = React.useState<"in" | "out">("in");
  const truckToUse = Array.isArray(truck) ? truck[0] : truck;

  React.useEffect(() => {
    if (truckToUse) {
      setDirection((truckToUse.direction as "in" | "out") || "in");
    }
  }, [truckToUse]);

  const handleSave = async () => {
    try {
      await updateEntryDirection(truckToUse.id, direction);
      if (onDirectionChange) {
        onDirectionChange(truckToUse, direction);
      }
      onClose();
    } catch (error) {
      console.error("Error updating truck direction:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontFamily: "SigmaSans" }}>
        Edit Direction - {truckToUse?.registration}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Change the direction for this vehicle entry.
        </DialogContentText>
        <FormControl fullWidth>
          <InputLabel id="direction-select-label">Direction</InputLabel>
          <Select
            labelId="direction-select-label"
            value={direction}
            label="Direction"
            onChange={(e) => setDirection(e.target.value as "in" | "out")}
          >
            <MenuItem value="in">In</MenuItem>
            <MenuItem value="out">Out</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
